// extracted by mini-css-extract-plugin
export default {"download":"styles_download__nH5Be","loadingSpinner":"styles_loadingSpinner__4+kbs"};